<template>
  <v-card
    :width="$vuetify.breakpoint.xs ? '100%' : maxWidth"
    :class="{
      'plan--not-available': !plan.available_to_user,
      'ml-2': $vuetify.breakpoint.smAndUp && !noLeftMargin,
      'mr-2': $vuetify.breakpoint.smAndUp && !noRightMargin,
    }"
    flat
    style="border-radius: 0; display: flex; flex-flow: column nowrap"
    :style="{
      'box-shadow': noShadow ? 'none' : '0px 0px 16px 0px rgba(0, 0, 0, 0.12)',
    }"
  >
    <v-card-title>
      <v-layout
        column
        class="grey--text text--darken-3"
      >
        <div
          v-if="showName"
          class="headline text-xs-center"
        >
          {{ plan.name }}
        </div>
        <v-scale-transition mode="out-in">
          <v-layout
            :key="price"
            align-baseline
            justify-center
          >
            <span style="font-size: 3.5em; font-weight: bold">{{
              price | price
            }}</span>
            <span
              class="ml-1"
              style="font-size: 2em"
            >€</span>
          </v-layout>
        </v-scale-transition>
        <div class="text-xs-center grey--text nowrap price-unit">
          {{ $t(plan.price_unit) || '&nbsp;' }}
        </div>
      </v-layout>
    </v-card-title>
    <v-divider />
    <v-card-text class="pb-0">
      <table class="featuretable">
        <tr>
          <td>
            <v-icon color="success">
              check
            </v-icon>
          </td>
          <td>
            {{ $t('contentCreatorPlanProduceForOwnGroups') }}
          </td>
        </tr>
        <tr>
          <td>
            <v-icon
              v-if="plan.production_limit_per_month === null"
              color="success"
            >
              all_inclusive
            </v-icon>
            <span
              v-else
              class="title success--text"
            >
              {{ plan.production_limit_per_month }}
            </span>
          </td>
          <td>
            <span v-if="plan.production_limit_per_month !== null">{{
              $t('contentCreatorPlanProductionLimitPerMonth')
            }}</span>
            <span v-else>{{
              $t('contentCreatorPlanProductionLimitPerMonthUnlimited')
            }}</span>
          </td>
        </tr>
        <!-- <tr>
          <td>
            <v-icon
              v-if="plan.produced_content_available_for_months === null"
              color="success"
            >
              all_inclusive
            </v-icon>
            <span
              v-else
              class="title success--text"
            >
              {{ plan.produced_content_available_for_months }}
            </span>
          </td>
          <td>
            <span v-if="plan.produced_content_available_for_months !== null">{{
              $t('contentCreatorPlanContentAvailable')
            }}</span>
            <span v-else>{{
              $t('contentCreatorPlanContentAvailableUnlimited')
            }}</span>
          </td>
        </tr> -->
        <tr>
          <td>
            <v-icon
              v-if="plan.can_share_produced_content_to_facebook"
              medium
              color="success"
            >
              check
            </v-icon>
            <v-icon
              v-else
              medium
              color="error lighten-1"
            >
              clear
            </v-icon>
          </td>
          <td>
            {{ $t('contentCreatorPlanFacebookSharing') }}
          </td>
        </tr>
        <tr>
          <td>
            <v-icon
              v-if="plan.can_edit_produced_content"
              medium
              color="success"
            >
              check
            </v-icon>
            <v-icon
              v-else
              medium
              color="error lighten-1"
            >
              clear
            </v-icon>
          </td>
          <td>
            {{ $t('contentCreatorPlanEditProducedContent') }}
          </td>
        </tr>
        <tr>
          <td>
            <v-icon
              v-if="plan.can_order_custom_templates"
              medium
              color="success"
            >
              check
            </v-icon>
            <v-icon
              v-else
              medium
              color="error lighten-1"
            >
              clear
            </v-icon>
          </td>
          <td>
            {{ $t('contentCreatorPlanOrderCustomTemplates') }}
          </td>
        </tr>
        <tr>
          <td>
            <v-icon
              medium
              color="success"
            >
              check
            </v-icon>
          </td>
          <td>
            <span v-if="billingPeriod === 'MONTHLY'">
              {{ $t('contentCreatorPlanCancellableMonthly') }}
            </span>
            <span v-else-if="billingPeriod === 'YEARLY'">
              {{ $t('contentCreatorPlanCancellableYearly') }}
            </span>
          </td>
        </tr>
        <!-- <tr v-if="false">
          <td>
            <v-icon
              v-if="plan.can_target_association_groups"
              medium
              color="success"
            >
              add_business
            </v-icon>
            <v-icon
              v-else
              medium
              color="error lighten-1"
            >
              clear
            </v-icon>
          </td>
          <td>
            {{ $t('contentCreatorPlanTargetAssociationGroups') }}
            <v-tooltip
              v-if="plan.can_target_association_groups"
              bottom
              style="cursor: help"
            >
              <v-icon
                slot="activator"
                small
              >
                info
              </v-icon>
              <span>
                {{ $t('contentCreatorPlanTargetAssociationGroupsInfo') }}
              </span>
            </v-tooltip>
          </td>
        </tr> -->
      </table>
    </v-card-text>
    <v-card-text class="pt-0 mt-auto">
      <v-btn
        v-if="!hideActions"
        class="open-booking-dialog-btn"
        :class="{
          'msr--text': !isRecommended || isCurrent,
          'msr white--text': isRecommended && !isCurrent,
        }"
        block
        large
        round
        :disabled="confirmButtonDisabled"
        :outline="!(isRecommended || isCurrent)"
        :flat="(isRecommended || isCurrent) && !confirmButtonDisabled"
        data-cy="contentcreator-plan-card-confirm-btn"
        @click="$emit('selected')"
      >
        {{ confirmButtonLabel }}
      </v-btn>
      <v-btn
        v-if="!hideActions && showDeclineAnotherTestButton"
        class="open-booking-dialog-btn info white--text mt-3"
        block
        large
        round
        :disabled="confirmButtonDisabled"
        :outline="!(isRecommended || isCurrent)"
        :flat="!confirmButtonDisabled"
        @click="$emit('selected-decline-another-test')"
      >
        {{ $t('contentCreatorBookWithoutAnotherTest') }}
      </v-btn>
      <small
        v-if="confirmButtonDisabled && isDemoUser"
        class="warning--text"
      >
        {{ $t('contentCreatorPlanBookingNotAvailableForDemoUser') }}
      </small>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    plan: {
      type: Object,
      required: true,
    },
    billingPeriod: {
      type: String,
      default: 'MONTHLY',
      validate: function (period) {
        return ['MONTHLY', 'YEARLY'].includes(period);
      },
    },
    isRecommended: {
      type: Boolean,
      default: true,
    },
    showName: {
      type: Boolean,
      default: false,
    },
    showTestPeriod: {
      type: Boolean,
      default: true,
    },
    showDeclineAnotherTestButton: {
      type: Boolean,
      default: false,
    },
    isCurrent: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: String,
      default: '100%',
    },
    noLeftMargin: {
      type: Boolean,
      default: false,
    },
    noRightMargin: {
      type: Boolean,
      default: false,
    },
    noShadow: {
      type: Boolean,
      default: false,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    price() {
      if (this.billingPeriod == 'YEARLY') {
        return this.plan.price_yearly;
      }
      return this.plan.price_monthly;
    },
    confirmButtonLabel() {
      if (this.showTestPeriod) {
        return this.$t('contentCreatorPlanTestNow');
      }
      return this.$t('contentCreatorPlanBookNow');
    },
    isDemoUser() {
      return this.$userprofile && this.$userprofile.is_demo;
    },
    confirmButtonDisabled() {
      return !this.plan.available_to_user || this.isDemoUser;
    },
  },
};
</script>

<style scoped>
.plan--not-available {
  opacity: 0.66;
}

.featuretable td:first-child {
  text-align: center;
}
.featuretable td:nth-child(2) {
  font-size: 12px;
}
.featuretable td {
  padding-right: 12px;
  padding-bottom: 8px;
}

.price-unit {
  font-size: 19px;
  font-weight: 500;
}

.open-booking-dialog-btn {
  padding-left: 8px;
  padding-right: 8px;
  min-height: 42px;
  height: auto;
}
.open-booking-dialog-btn >>> .v-btn__content {
  white-space: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/ContentCreatorPlanCard.vue